import { Navigate } from "react-router-dom";
import { useAuthStore } from "../store/authStore";
import { firstBusinessRoute } from "../utils/navigationAccess";
export function DefaultBusinessRoute() {
  const user = useAuthStore((s) => s.user);
  return <Navigate replace to={firstBusinessRoute(user?.permissions ?? [])} />;
}
